// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const edgeAccessOptionsResponseSchema = z.object({
  "options": z.array(z.object({
    "id": z.string(),
    "capabilities": z.array(z.string()),
    "state": z.enum(["off", "partial", "on"]),
    "can_enable": z.boolean(),
    "blocked_reason": z.string().optional()
  }).strict())
}).strict();

export const edgeSiteSchema = z.object({
  "site_id": z.string().uuid(),
  "name": z.string(),
  "issuer": z.string().url(),
  "status": z.enum(["pending", "active"]),
  "runtimes": z.number().int().min(0),
  "approved_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "detail": z.string()
});

export const edgeManifestFactsSchema = z.object({
  "evidence_key_thumbprint": z.string().regex(new RegExp("^[A-Za-z0-9_-]{43}$")).optional(),
  "image_digest": z.string().regex(new RegExp("^sha256:[0-9a-f]{64}$")),
  "plane_ca_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "config_sign_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "evidence_key_class": z.enum(["pod-bound", "pinned-key"]),
  "create_set": z.object({
    "asserted": z.boolean(),
    "principals": z.array(z.string()).optional(),
    "verbs": z.array(z.string()).optional()
  })
});

export const edgeApprovalSchema = z.object({
  "id": z.string().uuid(),
  "manifest": z.object({
    "format": z.enum(["edge_manifest-v1", "edge_manifest-v2"]),
    "edge_id": z.string(),
    "site_id": z.string().uuid(),
    "site_issuer": z.string(),
    "runtime_name": z.string(),
    "role": z.enum(["broker", "web", "egress", "privileged"]),
    "capabilities": z.array(z.string()).optional(),
    "workload": z.object({
      "issuer": z.string(),
      "audience": z.string(),
      "subject": z.string(),
      "jwks_url": z.string().optional(),
      "jwks_tls_trust_pem": z.string().optional(),
      "signing_keys_pem": z.array(z.string()).optional()
    }),
    "image_digest": z.string(),
    "plane_ca_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "config_sign_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "evidence_key_class": z.string(),
    "unattended_growth": z.enum(["allowed", "per_instance_approval"]),
    "max_live_instances": z.number().int().min(1).max(1000),
    "create_set": z.object({
      "asserted": z.boolean(),
      "principals": z.array(z.string()).optional(),
      "verbs": z.array(z.string()).optional()
    }),
    "registration": z.object({
      "intent_id": z.string().uuid(),
      "proposal_id": z.string().uuid(),
      "proposal_digest": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "enrollment_spki_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "tenant_id": z.string().uuid(),
      "tenant_origin": z.string(),
      "deployment_id": z.string(),
      "deployment_edge_ids": z.array(z.string())
    }).optional()
  }),
  "manifest_hash": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "edge_id": z.string(),
  "required_approvals": z.number().int().min(1).max(2),
  "state": z.enum(["pending", "approved", "cancelled", "expired", "superseded"]),
  "created_by": z.string().uuid(),
  "created_by_scope": z.enum(["tenant", "platform"]),
  "created_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "approved_at": z.string().datetime({ offset: true }).optional(),
  "signatures": z.array(z.object({
    "approver_id": z.string().uuid(),
    "approver_scope": z.enum(["tenant", "platform"]),
    "credential_id": z.string().uuid(),
    "user_verified": z.boolean(),
    "signed_at": z.string().datetime({ offset: true }),
    "aaguid": z.string().uuid().optional()
  })),
  "transparency_leaf": z.number().int().min(0).optional()
});

export const edgeCombinedApprovalSchema = z.object({
  "id": z.string().uuid(),
  "manifest": z.object({
    "format": z.enum(["edge_manifest-v4"]),
    "edge_id": z.string(),
    "site_id": z.string().uuid(),
    "site_issuer": z.string(),
    "runtime_name": z.string(),
    "role": z.enum(["broker", "web", "egress", "privileged"]),
    "capabilities": z.array(z.string()).optional(),
    "workload": z.object({
      "issuer": z.string(),
      "audience": z.string(),
      "subject": z.string(),
      "jwks_url": z.string().optional(),
      "jwks_tls_trust_pem": z.string().optional(),
      "signing_keys_pem": z.array(z.string()).optional()
    }),
    "image_digest": z.string(),
    "plane_ca_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "config_sign_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "evidence_key_class": z.string(),
    "unattended_growth": z.enum(["allowed", "per_instance_approval"]),
    "max_live_instances": z.number().int().min(1).max(1000),
    "create_set": z.object({
      "asserted": z.boolean(),
      "principals": z.array(z.string()).optional(),
      "verbs": z.array(z.string()).optional()
    }),
    "registration": z.object({
      "evidence_key_thumbprint": z.string().regex(new RegExp("^[A-Za-z0-9_-]{43}$")),
      "platform_override_reason": z.string().min(20).max(2000).optional(),
      "intent_id": z.string().uuid(),
      "proposal_id": z.string().uuid(),
      "proposal_digest": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "enrollment_spki_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "tenant_id": z.string().uuid(),
      "tenant_origin": z.string(),
      "deployment_id": z.string(),
      "deployment_edge_ids": z.array(z.string()),
      "replaces_approval_id": z.string().uuid().optional()
    })
  }),
  "manifest_hash": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "edge_id": z.string(),
  "required_approvals": z.number().int().min(1).max(2),
  "state": z.enum(["pending", "approved", "cancelled", "expired", "superseded"]),
  "created_by": z.string().uuid(),
  "created_by_scope": z.enum(["tenant", "platform"]),
  "created_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "approved_at": z.string().datetime({ offset: true }).optional(),
  "signatures": z.array(z.object({
    "approver_id": z.string().uuid(),
    "approver_scope": z.enum(["tenant", "platform"]),
    "credential_id": z.string().uuid(),
    "user_verified": z.boolean(),
    "signed_at": z.string().datetime({ offset: true }),
    "aaguid": z.string().uuid().optional()
  })),
  "transparency_leaf": z.number().int().min(0).optional()
});

export const edgeImageUpdateApprovalSchema = z.object({
  "id": z.string().uuid(),
  "manifest": z.object({
    "format": z.enum(["edge_manifest-v3"]),
    "edge_id": z.string(),
    "site_id": z.string().uuid(),
    "site_issuer": z.string(),
    "runtime_name": z.string(),
    "role": z.enum(["broker", "web", "egress", "privileged"]),
    "capabilities": z.array(z.string()).optional(),
    "workload": z.object({
      "issuer": z.string(),
      "audience": z.string(),
      "subject": z.string(),
      "jwks_url": z.string().optional(),
      "jwks_tls_trust_pem": z.string().optional(),
      "signing_keys_pem": z.array(z.string()).optional()
    }),
    "image_digest": z.string(),
    "plane_ca_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "config_sign_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
    "evidence_key_class": z.string(),
    "unattended_growth": z.enum(["allowed", "per_instance_approval"]),
    "max_live_instances": z.number().int().min(1).max(1000),
    "create_set": z.object({
      "asserted": z.boolean(),
      "principals": z.array(z.string()).optional(),
      "verbs": z.array(z.string()).optional()
    }),
    "registration": z.object({
      "intent_id": z.string().uuid(),
      "proposal_id": z.string().uuid(),
      "proposal_digest": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "enrollment_spki_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
      "tenant_id": z.string().uuid(),
      "tenant_origin": z.string(),
      "deployment_id": z.string(),
      "deployment_edge_ids": z.array(z.string()),
      "replaces_approval_id": z.string().uuid()
    })
  }),
  "manifest_hash": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "edge_id": z.string(),
  "required_approvals": z.number().int().min(1).max(2),
  "state": z.enum(["pending", "approved", "cancelled", "expired", "superseded"]),
  "created_by": z.string().uuid(),
  "created_by_scope": z.enum(["tenant", "platform"]),
  "created_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "approved_at": z.string().datetime({ offset: true }).optional(),
  "signatures": z.array(z.object({
    "approver_id": z.string().uuid(),
    "approver_scope": z.enum(["tenant", "platform"]),
    "credential_id": z.string().uuid(),
    "user_verified": z.boolean(),
    "signed_at": z.string().datetime({ offset: true }),
    "aaguid": z.string().uuid().optional()
  })),
  "transparency_leaf": z.number().int().min(0).optional()
});

export const edgeApprovalBeginSchema = z.object({
  "ceremony_id": z.string().uuid(),
  "options": z.object({
    "challenge": z.string(),
    "rpId": z.string().optional(),
    "timeout": z.number().int().optional(),
    "userVerification": z.enum(["required", "preferred", "discouraged"]).optional(),
    "allowCredentials": z.array(z.object({
      "type": z.enum(["public-key"]),
      "id": z.string(),
      "transports": z.array(z.enum(["ble", "hybrid", "internal", "nfc", "usb", "smart-card"])).optional()
    })).optional()
  })
});

export const edgeRegistrationProposalSchema = z.object({
  "proposal_id": z.string().uuid(),
  "digest": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "enrollment_spki_sha256": z.string().regex(new RegExp("^[0-9a-f]{64}$")),
  "state": z.enum(["pending", "approved", "rejected"]),
  "attestation": z.object({
    "method": z.enum(["", "k8s_sat"]),
    "issuer": z.string(),
    "audience": z.string(),
    "subject": z.string(),
    "signing_keys_pem": z.array(z.string()).optional(),
    "jwks_url": z.string().optional(),
    "jwks_tls_trust_pem": z.string().optional()
  }),
  "manifest_facts": edgeManifestFactsSchema,
  "code_expires_at": z.string().datetime({ offset: true }).optional(),
  "enrollment_code": z.string().optional(),
  "approval_id": z.string().uuid().optional()
});

export const edgeRegistrationSchema = z.object({
  "intent_id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "tenant_origin": z.string().url(),
  "edge_id": z.string(),
  "role": z.string(),
  "deployment_id": z.string(),
  "deployment_edge_ids": z.array(z.string()),
  "state": z.enum(["pending", "authorised", "cancelled", "expired"]),
  "lifecycle_operation": z.enum(["install", "software_update", "certificate_recovery", "legacy_replacement"]),
  "expires_at": z.string().datetime({ offset: true }),
  "site_id": z.string().uuid(),
  "site_name": z.string(),
  "runtime_name": z.string(),
  "approval_id": z.string().uuid().optional(),
  "approved_digest": z.string().regex(new RegExp("^[0-9a-f]{64}$")).optional(),
  "approval_current": z.boolean(),
  "image_update_supported": z.boolean(),
  "replaces_approval_id": z.string().uuid().optional(),
  "prior_image_digest": z.string().regex(new RegExp("^sha256:[0-9a-f]{64}$")).optional(),
  "proposals": z.array(edgeRegistrationProposalSchema)
});

export const relayAdmissionPolicySchema = z.object({
  "mode": z.enum(["portal_launched", "declared_egress", "any_source"]),
  "declared_egress_ranges": z.array(z.string()),
  "updated_at": z.string().datetime({ offset: true }).optional()
}).strict();

export const servingCertificateRevocationSchema = z.object({
  "reason": z.enum(["key_compromise", "superseded", "cessation_of_operation"]),
  "requested_at": z.string().datetime({ offset: true }),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "attempts": z.number().int(),
  "last_error": z.string().optional()
});

export const servingCertificateSchema = z.object({
  "order_id": z.string().uuid(),
  "names": z.array(z.string()),
  "serial": z.string(),
  "not_after": z.string().datetime({ offset: true }),
  "renew_after": z.string().datetime({ offset: true }),
  "revocation": servingCertificateRevocationSchema.optional()
});

export const outsideCertificateSchema = z.object({
  "serial": z.string(),
  "issuer": z.string(),
  "names": z.array(z.string()),
  "not_before": z.string().datetime({ offset: true }),
  "not_after": z.string().datetime({ offset: true }),
  "uncollected": z.boolean()
});

export const issuanceObservationSchema = z.object({
  "checked_at": z.string().datetime({ offset: true }).optional(),
  "outside": z.array(outsideCertificateSchema)
});

export const servingCertificateListSchema = z.object({
  "items": z.array(servingCertificateSchema),
  "observation": issuanceObservationSchema.optional()
});

export const edgeContainmentReceiptSchema = z.object({
  "keys_contained": z.number().int(),
  "sessions_closed": z.number().int(),
  "leaves_revoked": z.array(z.string())
});
